import { Heading, HeadingProps } from "@chakra-ui/react";
import { ReactNode } from "react";

function PageTitle({ children, ...props }: { children: ReactNode} & HeadingProps) {
    return <Heading as='h2' fontWeight={600} fontSize='32px' lineHeight='48px' display={props.display} pb={props.pb}>{ children }</Heading>
}

export default PageTitle;